import CalculationTableService from "../../service/CalculationTableService";

const newCalculation = {
    index: null,
    formula: null,
    culture: [],
    sensor_high: null,
    sensor_low: null,
    soil_type: [],
    date_from: null,
    date_to: null,
    recommendation: null,
    duplicate: false
};

const calculationFilter = {
    formula: null,
    culture: [],
    soil_type: [],
    countries: [],
    date_from: null,
    date_to: null,
    recommendation: null
};

const initialState = {
    newCalculation: { ...newCalculation },
    calculationFilter: { ...calculationFilter },
    calculationData: {},
    duplicate: null,
    id: null
};

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async fetchCalculation({ commit, state }) {
            try {
                const resp = await CalculationTableService.get(state.duplicate, state.id);
                if (resp.status === 200) {
                    commit("setCalculation", resp.data);
                }
            } catch (e) {
                console.log(e);
            }
        },
        async editCalculation({ dispatch }, editData) {
            try {
                editData.duplicate = false;
                // if (!editData.sensor_high && !editData.sensor_low) {
                //     dispatch('app/showSnackbar', {
                //         bool: true,
                //         message: 'Please choose sensor',
                //         type: 'fail'
                //     }, {root: true})
                //     return;
                // }
                const resp = await CalculationTableService.put(editData);
                if (resp.status === 200) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Calculation updated",
                            type: "success"
                        },
                        { root: true }
                    );
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Python formula is not correct",
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },
        async handleNewCalculationClick({ state, commit, dispatch }) {
            try {
                const resp = await CalculationTableService.post(state.newCalculation);

                if (resp.status === 201) {
                    commit("resetNewCalculation");
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "New calculation created",
                            type: "success"
                        },
                        { root: true }
                    );
                    dispatch("fetchCalculation");
                } else {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Python formula is not correct",
                            type: "fail"
                        },
                        { root: true }
                    );
                }
            } catch (e) {
                console.log(e);
            }
        },
        async duplicateCalculation({ dispatch, commit, state }, data) {
            try {
                let resp = null;
                if (confirm("Are you sure?")) {
                    commit("setDuplicate", data.id);
                    data.duplicate = state.duplicate;
                    resp = await CalculationTableService.post(data);
                }
                if (resp.status === 201) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Calculation duplicated",
                            type: "success"
                        },
                        { root: true }
                    );
                    dispatch("fetchCalculation");
                }
            } catch (e) {
                console.log(e);
            }
        },
        async deleteCalculation({ dispatch }, data) {
            try {
                let resp = null;
                if (confirm("Are you sure?")) {
                    resp = await CalculationTableService.delete(data.id, data.recommendation);
                }
                if (resp.status === 200) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Calculation deleted",
                            type: "success"
                        },
                        { root: true }
                    );
                    dispatch("fetchCalculation");
                }
            } catch (e) {
                console.log(e);
            }
        },
        async refreshCalculation({ dispatch }, id) {
            try {
                let resp = null;
                if (confirm("Are you sure?")) {
                    resp = await CalculationTableService.refresh(id);
                    if (resp.status === 200) {
                        dispatch(
                            "app/showSnackbar",
                            {
                                bool: true,
                                message: "Started updating calculations, this can take a few minutes to finish",
                                type: "success"
                            },
                            { root: true }
                        );
                        dispatch("fetchCalculation");
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        async sendRecommendationEmail({ dispatch }) {
            try {
                const resp = await CalculationTableService.email();
                if (resp.status === 200) {
                    dispatch(
                        "app/showSnackbar",
                        {
                            bool: true,
                            message: "Email was sent",
                            type: "success"
                        },
                        { root: true }
                    );
                    dispatch("fetchCalculation");
                }
            } catch (e) {
                console.log(e);
            }
        },
        clearCalculationFilterDate({ state }, dateType) {
            if (dateType === "from") {
                state.calculationFilter.date_from = null;
            }

            if (dateType === "to") {
                state.calculationFilter.date_to = null;
            }
        }
    },
    mutations: {
        setTableData(state, data) {
            state.tableData = data;
        },
        resetNewCalculation(state) {
            state.newCalculation = { ...newCalculation };
        },
        setCalculation(state, data) {
            state.calculationData = data;
        },
        setDuplicate(state, data) {
            state.duplicate = true;
            state.id = data;
        },
        setNewCalcCultures(state, culture) {
            state.newCalculation = { ...state.newCalculation, culture };
        },
        setNewCalcIndex(state, data) {
            state.newCalculation.index = data.index;
        }
        // clearCalculationFilterDate(state, dateType) {
        //     state.calculationFilter.date_from = null;
        //     state.calculationFilter.date_to = null;
        //     calculationFilter.date_from = null;
        //     calculationFilter.date_to = null;
        //     if (dateType === "from") {
        //         state.calculationFilter.date_from = null;
        //     }

        //     if (dateType === "to") {
        //         state.calculationFilter.date_to = null;
        //     }
        //     console.log("mida vittu_???ASdfasfa");
        // }
    },
    getters: {
        getCalculationsOrderedByIndex(state) {
            /*
             * Sorts calculations by index, first by the letter and then by the number following the letter
             * */
            return state.calculationData.sort((a, b) => {
                try {
                    const letterA = a.index.replace(/[0-9]*/g, "");
                    const numberA = parseInt(a.index.replace(/[a-zA-z]*/g, ""));
                    const letterB = b.index.replace(/[0-9]*/g, "");
                    const numberB = parseInt(b.index.replace(/[a-zA-z]*/g, ""));
                    return letterB > letterA || numberB - numberA;
                } catch {
                    return 0;
                }
            });
        },
        getNextCalculationIndex(state, getters) {
            const orderedCalculations = getters.getCalculationsOrderedByIndex;
            const highestCalculationIndex = orderedCalculations[0]?.index;
            if (!highestCalculationIndex) return "";
            let lowestMissingNumber = parseInt(highestCalculationIndex.replace(/[a-zA-z]*/g, "")) + 1;
            // find the first missing index
            for (let i = 1; i <= orderedCalculations.length; i++) {
                const currentCalculationIndex = orderedCalculations[orderedCalculations.length - i]?.index;
                const number = parseInt(currentCalculationIndex.replace(/[a-zA-z]*/g, ""));
                if (number !== i) {
                    lowestMissingNumber = i;
                    break;
                }
            }
            try {
                const letter = highestCalculationIndex.replace(/[0-9]*/g, "");
                return `${letter}${lowestMissingNumber}`;
            } catch {
                return "";
            }
        },
        getFilteredCalculations(state) {
            const { calculationFilter } = state;

            const filterBy = (filter, calculationValue) => {
                return filter.length === 0 || filter.every(value => calculationValue.includes(value));
            };

            return state.calculationData.filter(calculation => {
                return (
                    (!calculationFilter.formula || calculation.formula.includes(calculationFilter.formula)) &&
                    filterBy(calculationFilter.culture, calculation.culture) &&
                    filterBy(calculationFilter.soil_type, calculation.soil_type) &&
                    filterBy(calculationFilter.countries, calculation.countries) &&
                    (!calculationFilter.date_from ||
                        new Date(calculation.date_from) >= new Date(calculationFilter.date_from)) &&
                    (!calculationFilter.date_to ||
                        new Date(calculation.date_to) <= new Date(calculationFilter.date_to)) &&
                    (!calculationFilter.recommendation ||
                        calculation.recommendation === calculationFilter.recommendation)
                );
            });
        }
    }
};
